import './bootstrapFresh';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AppErrorBoundary } from '@components/AppErrorBoundary';
import { AuthProvider } from '@contexts/AuthContext';
import { ToastProvider } from '@contexts/ToastContext';
import { SignupFlowProvider } from '@contexts/SignupFlowContext';
import { router } from './router';
import './i18n/config';
import './styles.css';
import './styles/skeleton.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, error: unknown) => {
        const status = (error as { response?: { status?: number } })?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppErrorBoundary>
        <AuthProvider>
          <SignupFlowProvider>
            <ToastProvider>
              <RouterProvider router={router} />
            </ToastProvider>
          </SignupFlowProvider>
        </AuthProvider>
      </AppErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
